export enum LineOfBusiness {
  Commercial = 'Commercial',
  Medicaid = 'Medicaid',
  Medicare = 'Medicare',
  MedicareAdvantage = 'Medicare Advantage',
}
